module.exports = __webpack_public_path__ + "static/media/124.fc67259b.png";